import React, { useRef } from 'react';
import { Box, Button, InputAdornment } from '@mui/material';
import { useSnackbar } from '../contexts/SnackbarContext';
import { CustomTextField } from '../styles/SharedStyles';

const DynamicTextFields = ({ fields, showCopyButton = false }) => {
    const { showSnackbar } = useSnackbar();
    const inputRefs = useRef([]); // Create an array of refs for each field

    const handleCopy = (value, index) => {
      navigator.clipboard.writeText(value); // Copies the value to the clipboard
      showSnackbar('复制成功，请去贴贴', 'info', null, false);
      if (inputRefs.current[index]) {
        inputRefs.current[index].focus(); // Focus the corresponding input field
      }
    };
  
    return (
      <Box sx={{ width: '100%', minWidth: 0, boxSizing: 'border-box' }}>
        {fields.map((field, index) => (
          <Box key={index} sx={{ marginBottom: 2, minWidth: 0, width: '100%', boxSizing: 'border-box' }}>
            <CustomTextField
                fullWidth
                variant="outlined"
                inputRef={(el) => (inputRefs.current[index] = el)} 
                label={field.label}
                defaultValue={field.value}
                id={`outlined-start-adornment-${index}`}
                sx={{
                  width: '100%',
                  minWidth: 0,
                  '& .MuiInputBase-root': {
                    minWidth: 0,
                    maxWidth: '100%',
                  },
                }}
                slotProps={{
                    input: {
                        readOnly: true,
                        sx: {
                          color: '#fff',
                          minWidth: 0,
                          '& input': {
                            minWidth: 0,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          },
                        },
                        endAdornment: showCopyButton && (
                            <InputAdornment
                              position="end"
                              sx={{
                                marginLeft: 1,
                                marginRight: 0.5,
                                flexShrink: 0,
                              }}
                            >
                                <Button
                                  variant="contained"
                                  className="primary-button"
                                  onClick={() => handleCopy(field.value, index)}
                                  sx={{
                                    minWidth: '56px',
                                    px: 1.5,
                                    py: 0.5,
                                    my: 0.5,
                                    flexShrink: 0,
                                  }}
                                >
                                  复制
                                </Button>
                            </InputAdornment>)
                    },
                }}
            />
          </Box>
        ))}
      </Box>
    );
};

export default DynamicTextFields;